module.exports = __webpack_public_path__ + "img/silver.e7d315ba.svg";